/*
 * The panel's error boundary (plan §8). A render error anywhere in the
 * panel, or a lazy CopilotRoot chunk that fails to load, renders nothing
 * for the rest of the page's life: the page itself stays.
 *
 * The one class component in the feature, against react-components.mdc's
 * function components: React 18 has no hook for an error boundary, and no
 * new package may come in (DR7 bars react-error-boundary).
 *
 * It logs once: a fixed string and the error's code only, never the error
 * (L13), through the logger that never throws (L12).
 *
 * In React 18 development builds an error a boundary caught still reaches
 * window's `error` event, which index.js turns into a replaced app.
 * Production builds don't do that, so check the boundary in Jest or a
 * production build, not under `npm start`.
 */
import React from "react";
import { logCopilotError } from "../domain/copilotLog";

export default class CopilotErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    logCopilotError("[copilot] the panel failed", error);
  }

  render() {
    const { failed } = this.state;
    const { children } = this.props;
    return failed ? null : children;
  }
}
